import { render } from "./ProgressThreeQuarterIcon.vue?vue&type=template&id=656fa02a&ts=true"
import script from "./ProgressThreeQuarterIcon.vue?vue&type=script&lang=ts"
export * from "./ProgressThreeQuarterIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__